import * as React from 'react';
import FAQAccordion, { FAQAccordionProps } from './FAQAccordion';
import { RestaurantFaq } from '@/lib/types/StoreType';
interface FAQListProps {
  faqs: RestaurantFaq[];
}
const FAQList = ({ faqs }: FAQListProps) => {
  return (
    <div id={'faq'} className="faq-list w-full space-y-3">
      {faqs?.map((faq: FAQAccordionProps, i) => {
        return (
          <FAQAccordion
            key={faq.id}
            id={faq.id}
            question={faq.question}
            answer={faq.answer}
            isLast={i !== 0 && i === faqs.length - 1}
          />
        );
      })}
    </div>
  );
};

export default FAQList;
